import { render, staticRenderFns } from "./MainDocument.vue?vue&type=template&id=2b74d010&scoped=true"
import script from "./MainDocument.vue?vue&type=script&lang=js"
export * from "./MainDocument.vue?vue&type=script&lang=js"
import style0 from "./MainDocument.vue?vue&type=style&index=0&id=2b74d010&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b74d010",
  null
  
)

export default component.exports